import { object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import {
  useEstimateEditorSettings,
  useVisibilityModeCellClassName,
  useEstimateTableSettings,
  useEstimateStructure,
  ExpandContainer,
  PinnableCell,
  DragHandleCell,
  ElementChatPopup,
} from "@tools";
import { Grid } from "@material-ui/core";
import classnames from "classnames";
import { NumericFormat } from "react-number-format";

export const TimelineUtilizationTeamMember = observer(({
  teamMember,
}) => {
  const { t } = useTranslation();
  const structure = useEstimateStructure();
  const { allowEdition, isPdfPrinterView, showChatThread } = useEstimateEditorSettings();
  const { fullSectionActions } = useEstimateTableSettings();

  const {
    usedRoundDecimals,
    usedThousandSeparator,
  } = structure.settings;

  const {
    name,
    treePath,
    isHidden,
    hideOnTimeline,
    displayHours,
  } = teamMember;

  const path = treePath.join("/");
  const timelinePath = "t" + path;
  
  const className = useVisibilityModeCellClassName(isHidden || hideOnTimeline);
  
  return (
    <Grid
      item container
      wrap="nowrap"
      className={classnames(
        "hoverRow bg-secondary preset-page",
        className
      )}
    >
      {
        !isPdfPrinterView && <DragHandleCell size="medium" displayHandle={allowEdition} />
      }
      <PinnableCell
        boldText
        hasStaticWidth
        allowOverflowDisplay
        tableDepth={3}
        wider={fullSectionActions}
        size="medium"
        actions={
          <NumericFormat
            displayType="text"
            value={displayHours}
            thousandSeparator={usedThousandSeparator}
            decimalSeparator="."
            suffix={t("times.h")}
            decimalScale={usedRoundDecimals}
            valueIsNumericString
            className="w-max text-lighter text-sm"
          />
        }
        containers={ <ExpandContainer tableDepth={3} size="medium" /> }
      >
        <Grid
          item
          container
          alignItems="center"
        >
          <span
            className={classnames(
              "name preset-timelineTitleText text-sm text-secondary",
              !name?.length && "semi-transparent"
            )}
          >
            { name || t("common.unnamed") }
          </span>
          {
            showChatThread &&
            <ElementChatPopup
              rowThread
              path={timelinePath}
              taskName={name || t("common.unnamed")}
            />
          }
        </Grid>
      </PinnableCell>
    </Grid>
  );
});

TimelineUtilizationTeamMember.propTypes = {
  teamMember: object.isRequired,
};
